import styled from "styled-components";

export const Actions = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 16px;
`;

export const CodeField = styled.div`
    max-width: 220px;
`;
